export const REPORT_GOS_ITEMS_FETCH = 'REPORT_GOS_ITEMS_FETCH';
